const defaultHours = () => ({ open: "10:00", close: "19:00", isOpen: true });
export function createBookingSettingsState() {
  return {
    loading: true,
    onlineBookingEnabled: true,
    businessHours: {
      mon: defaultHours(),
      tue: defaultHours(),
      wed: defaultHours(),
      thu: defaultHours(),
      fri: defaultHours(),
      sat: { open: "10:00", close: "18:00", isOpen: true },
      sun: { open: "10:00", close: "18:00", isOpen: false },
    },
    bookingInterval: 30,
    maxConcurrent: 1,
    holidays: [],
    newHoliday: "",
    dayOrder: ["mon", "tue", "wed", "thu", "fri", "sat", "sun"],
    dayLabels: {
      mon: "월",
      tue: "화",
      wed: "수",
      thu: "목",
      fri: "금",
      sat: "토",
      sun: "일",
    },
    saveTimeout: null,
  };
}
